<template>
  <div class="container admindashboard">
    <div class="row pt-10 pb-5 text-left container-content" style="margin-left:0; margin-right:0">
      <h4 class="heading mt-5">New Member/Observer Onboarding Checklist</h4>
      <div class="mt-3" style="width: 100%">
        <b-row class="mt-3 mb-3">
          <b-col>
            <div>
              <h5><b>Organization:</b> {{orgName}}</h5><hr>
              <input type="checkbox" id="confluence" value="confluence" v-model="checkedNames">
              <label for="Confluence Access">Confluence Access</label><br><br>
              <input type="checkbox" id="slack" value="slack" v-model="checkedNames">
              <label for="Slack Access">Slack Access</label><br><br>
              <input type="checkbox" id="member" value="member" v-model="checkedNames">
              <label for="New Members Orientation">New Members Orientation</label>
            </div>
            <hr>
            <b-button @click="goBack" class="btn btn-primary">Back</b-button>
            <b-button @click="save" class="btn btn-primary" style="float:right">Save</b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BButton
} from "bootstrap-vue";
import { mapActions } from "vuex";
export default {
  name: "CheckList",
  components: {
    BButton
  },
  data() {
      return {
        checkedNames: [],
        orgName: this.$store.state.organizationRequest.name,
        token: JSON.parse(this.$store.state?.userToken)?.accessToken
      }
    },
  methods: {
    ...mapActions([
        "saveChecklist",
    ]),
    goBack() {
      this.$router.push("/admindashboard");
    },
    save() {
      let req = [{
      "confluence": this.checkedNames.includes("confluence") ? true : false,
      "slack": this.checkedNames.includes("slack") ? true : false,
      "newMemberOrientation": this.checkedNames.includes("member") ? true : false,
      "organizationRequest": {
          "organizationRequestId": this.$store.state.organizationRequest.organizationRequestId,
          "name": this.$store.state.organizationRequest.name,
          "imisId": this.$store.state.organizationRequest.imisId
      }
    }, this.token]
    this.saveChecklist(req);
    // console.log("REQ",req);
    }
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if(this.$store.state.organizationRequest?.onboardingChecklist) {
      if(this.$store.state.organizationRequest?.onboardingChecklist?.confluence) {
        this.checkedNames.push('confluence');
      }
      if(this.$store.state.organizationRequest?.onboardingChecklist?.slack) {
        this.checkedNames.push('slack');
      }
      if(this.$store.state.organizationRequest?.onboardingChecklist?.newMemberOrientation) {
        this.checkedNames.push('member');
      }
    }
    // console.log("checkNames", this.checkedNames);
    // console.log("OrgRequest",this.$store.state.organizationRequest);
  },
  computed : {
    checkedComputed () {
      return this.checkedNames
    }
  }
};
</script>
<style scoped>
.heading {
  font-weight: 700;
  font-size: 29px;
  line-height: 34px;
  color: #1978a0;
}
.label {
  font-size: 100%;
  line-height: 1.5;
  color: #333;
  display: inline-block;
  padding: .2em .6em .3em 0;
}
input[type=checkbox] {
  margin: 4px 16px 0;
  top: 2px;
  position: relative;
}
@media (max-width: 575px){
  .container{
    padding: 10% !important;
  }
}
</style>
